/**
    * @fileoverview Generated Platform Configuration
    * @description Auto-generated during token build process
    * @generated 2026-01-21T14:22:41.815Z
    */

    export const CURRENT_PLATFORM = "mobile" as const;

    export type Platform = "tv" | "web" | "mobile";
  